module.exports = __webpack_public_path__ + "img/logo-min.a76bd607.jpg";